var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "topbar" }, [
      _c("i", { on: { click: _vm.toIndex } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox1" }, [
        _c(
          "div",
          {
            staticClass: "changeLangBtn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.moreLang()
              }
            }
          },
          [
            _vm._v(
              "\r\n          " + _vm._s(_vm.$t("language")) + "\r\n          "
            ),
            _c("em", { staticClass: "iconfont icon-een" }),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.changeLangBox,
                    expression: "changeLangBox"
                  }
                ],
                staticClass: "chooseLangUl"
              },
              _vm._l(_vm.langList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "chooseLangUlli",
                    on: {
                      click: function($event) {
                        _vm.setLanguage(item.id)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              })
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "changeLangBtn1",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.goLogin()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("homepage_button1")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "forget", attrs: { id: "forget" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShow,
                expression: "isShow"
              }
            ],
            staticClass: "forgetPsd"
          },
          [_vm._v(_vm._s(_vm.$t("setPass_title")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isShow,
                expression: "!isShow"
              }
            ],
            staticClass: "forgetPsd"
          },
          [_vm._v(_vm._s(_vm.$t("sucPass_title")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShow,
                expression: "isShow"
              }
            ],
            staticClass: "inputItem clearfix"
          },
          [
            _c("span", { staticClass: "account" }, [
              _vm._v(_vm._s(_vm.$t("setPass_txt1")))
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              attrs: { type: "password" },
              domProps: { value: _vm.password },
              on: {
                blur: _vm.checkPwd,
                focus: _vm.checkPwd1,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pwdShow1,
                    expression: "pwdShow1"
                  }
                ],
                staticClass: "s1"
              },
              [_vm._v(_vm._s(_vm.$t("setPass_txt2")))]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShow,
                expression: "isShow"
              }
            ],
            staticClass: "inputItem clearfix"
          },
          [
            _c("span", { staticClass: "account" }, [
              _vm._v(_vm._s(_vm.$t("setPass_txt1")))
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password1,
                  expression: "password1"
                }
              ],
              attrs: { type: "password" },
              domProps: { value: _vm.password1 },
              on: {
                blur: _vm.checkPwd2,
                focus: _vm.checkPwd3,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password1 = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pwdShow2,
                  expression: "pwdShow2"
                }
              ],
              staticClass: "s1",
              domProps: { textContent: _vm._s(_vm.pwdAgain) }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShow,
                expression: "isShow"
              }
            ],
            staticClass: "signIn",
            on: { click: _vm.sucess }
          },
          [_vm._v(_vm._s(_vm.$t("setPass_txt4")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isShow,
                expression: "!isShow"
              }
            ],
            staticClass: "signIn",
            staticStyle: { "margin-top": "60px" },
            on: { click: _vm.goHome }
          },
          [_vm._v(_vm._s(_vm.$t("sucPass_button")))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.warnShow,
                expression: "warnShow"
              }
            ],
            staticClass: "s11",
            domProps: { textContent: _vm._s(_vm.warinningText) }
          },
          [_vm._v(_vm._s(_vm.$t("signup_txt7")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bdf200b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bdf200b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setPwd.vue
// module id = null
// module chunks = 